import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {MenuButtonEvents} from '@fantasmagames/slot/src/modules/keypad/menuButton/MenuButtonEvents';
import {MainMenuEvents} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuEvents';
import {MainMenuModule, MENU} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuModule';
import {MainMenuView} from '@fantasmagames/slot/src/modules/mainmenu/MainMenuView';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {RelaxEvents} from '@fantasmagames/slot/src/integration/RelaxEvents';

export class MainMenuOpenState extends ModuleState<MainMenuView, MainMenuModule> {
	public onEnterState(): void {
		this.emit(MainMenuEvents.MAIN_MENU_OPEN);
		this.showMenu();
		this.showLastMenu();
	}

	public onLeaveState(): void {
		this.emit(MainMenuEvents.MAIN_MENU_CLOSED);
	}

	protected showMenu(): void {
		(this.view as MainMenuView).showMainMenu();
	}

	protected showLastMenu(): void {
		if (this.module._lastMenu === MENU.SETTINGS) {
			this.emit(MainMenuEvents.MAIN_MENU_SETTINGS_OPEN);
		} else if (this.module._lastMenu === MENU.INFO) {
			this.emit(MainMenuEvents.MAIN_MENU_INFO_OPEN);
		} else {
			this.module._lastMenu === MENU.PAYTABLE;
			this.emit(MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN);
		}
	}

	protected onCloseClicked(): void {
		this.module.gotoState(MainMenuModule.BASIC);
	}

	protected setupEvents(): void {
		this.on(SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onCloseClicked);
		this.on(MenuButtonEvents.MENU_BUTTON_CLICKED, this.onCloseClicked);
		this.on(MainMenuEvents.MAIN_MENU_CLOSE_CLICKED, this.onCloseClicked);
		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onCloseClicked);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onCloseClicked);
		this.on(RelaxEvents.SHOW_REALITY_CHECK, this.onCloseClicked);
		this.on(LogicEvents.ERROR_RESPONSE, this.onErrorResponse);
	}

	protected onErrorResponse(): void {
		this.module.gotoState(MainMenuModule.BASIC);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/mainmenu/states/MainMenuOpenState.ts